import { gql } from '@jupiter/ts-monorepo';

export const useCompanyStore = defineStore('company', () => {
    const company = ref(null);


    // 임시임. 입점몰이 되면 변경해야 되는데 그럴일이 있으려나 ㅇㅅㅇ?
    const getCompany = async () => {
        const _page = 1;
        const _limit = 1;
        const _offset = _limit * (_page - 1);

        const hasuraClient = await getHasuraClient();

        const where: any = {
            deleted_at: {
                _is_null: true,
            },
        };

        const response = await hasuraClient.query({
            query: SELECT_COMPANY,
            fetchPolicy: "network-only",
            variables: {
                limit: _limit,
                offset: _offset,
                where: where,
                order_by: { created_at: "desc_nulls_last" },
            },
        });

        if (response && response.data && response.data.company_companies.length > 0) {
            company.value = response.data.company_companies[0];
        }

        return response;
    };

    return {
        // data
        company,

        // methods
        getCompany,
    };
});


const SELECT_COMPANY = gql`
    query selectCompany(
        $limit: Int = 10
        $offset: Int = 0
        $where: company_companies_bool_exp
        $order_by: [company_companies_order_by!] = {}
    ) @cached {
        company_companies(
            limit: $limit
            offset: $offset
            where: $where
            order_by: $order_by
        ) {
            id
            name
            ceo
            business_number
            mail_order_sales_registration_number
            zonecode
            address
            detail_address
            contact
            email
            personal_information_protection_officer
        }
    }
`;